/* ETi MK4 Supra Widebody kit page: reservation form summary, LED add-on toggle, mobile sticky bar. */
(function () {
  'use strict';

  function parseAmount(text) {
    var match = String(text || '').replace(/,/g, '').match(/\d+(\.\d+)?/);
    return match ? parseFloat(match[0]) : NaN;
  }

  function formatUSD(value) {
    var hasCents = Math.round(value * 100) % 100 !== 0;
    return value.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  function initForm(form) {
    if (form.dataset.mk4Ready) return;
    form.dataset.mk4Ready = 'true';

    var options = form.querySelectorAll('[data-mk4-option]');
    var out = {
      build: form.querySelector('[data-mk4-out="build"]'),
      deposit: form.querySelector('[data-mk4-out="deposit"]'),
      balance: form.querySelector('[data-mk4-out="balance"]'),
      note: form.querySelector('[data-mk4-out="note"]')
    };

    function syncAddons() {
      Array.prototype.forEach.call(options, function (option) {
        var addonId = option.getAttribute('data-mk4-has-addon');
        if (!addonId) return;
        var wrap = form.querySelector('[data-mk4-addon-for="' + addonId + '"]');
        if (!wrap) return;
        var input = wrap.querySelector('input');
        input.disabled = !option.checked;
        if (!option.checked) input.checked = false;
        wrap.classList.toggle('is-disabled', !option.checked);
      });
    }

    function syncSummary() {
      var tier = form.querySelector('[data-mk4-tier]:checked');
      if (!tier || !out.build) return;
      var base = parseAmount(tier.getAttribute('data-price'));
      var isFrom = tier.getAttribute('data-from') === 'true';
      var extras = 0;
      var onRequest = [];

      Array.prototype.forEach.call(options, function (option) {
        if (!option.checked) return;
        var price = parseAmount(option.getAttribute('data-price'));
        if (!isNaN(price)) extras += price;
      });
      Array.prototype.forEach.call(form.querySelectorAll('[data-mk4-addon]'), function (addon) {
        if (addon.checked) onRequest.push(addon.getAttribute('data-mk4-addon-name') || 'add-on');
      });

      if (isNaN(base)) {
        out.build.textContent = 'Quoted with your spec';
        if (out.balance) out.balance.textContent = 'Quoted with your spec';
      } else {
        var deposit = base / 2;
        var total = base + extras;
        out.build.textContent = (isFrom ? 'From ' : '') + formatUSD(total);
        if (out.balance) out.balance.textContent = (isFrom ? 'From ' : '') + formatUSD(total / 2);
      }
      if (out.deposit) out.deposit.textContent = tier.getAttribute('data-deposit') || '';

      if (out.note) {
        var note = 'Freight is quoted and billed separately.';
        if (onRequest.length) note = onRequest.join(', ') + ': no extra charge. ' + note;
        if (isFrom) note = 'Starting price; your final spec is quoted with you. ' + note;
        if (extras > 0 && !isNaN(base)) note = '50% of your options (' + formatUSD(extras / 2) + ') is invoiced when your spec is confirmed. ' + note;
        out.note.textContent = note;
      }
    }

    form.addEventListener('change', function () {
      syncAddons();
      syncSummary();
    });
    syncAddons();
    syncSummary();

    if (form.hasAttribute('data-mk4-preview')) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var msg = form.querySelector('[data-mk4-msg]');
        if (msg) {
          msg.hidden = false;
          msg.textContent = 'Preview only. On the live page this adds the selected deposit to the cart with your options attached, then goes to checkout.';
        }
      });
    }
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-mk4-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var hero = root.querySelector('[data-mk4-hero-actions]');
    var reserve = root.querySelector('[data-mk4-reserve]');
    var state = { hero: true, reserve: false };

    function update() {
      var show = !state.hero && !state.reserve;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if ('inert' in bar) bar.inert = !show;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.target === hero) state.hero = entry.isIntersecting;
        if (entry.target === reserve) state.reserve = entry.isIntersecting;
      });
      update();
    }, { rootMargin: '0px 0px -10% 0px' });

    if (hero) observer.observe(hero);
    if (reserve) observer.observe(reserve);
    update();
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-mk4]');
    Array.prototype.forEach.call(roots, function (root) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-mk4-form]'), initForm);
      initSticky(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
